import featuredPlayersBg from '../assets/featured_players_bg.png';
import googlePlayImage from '../assets/googleplayLarge_.png';
import appleStoreImage from '../assets/appstoreLarge_.png';
import playerAppLogo from '../assets/PlayerAppLogoGreen.png';
import { getSingleModel } from '../utils/helpers';
import { BigButtons } from '../components/reusable/buttons/Buttons';
import { useNavigate, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';

const Placeholder = ({ pageTitle }) => {
    const isLoggedIn = getSingleModel('auth')?.authUser?.authenticated;
    const navigate = useNavigate();
    const location = useLocation();
    const [isVisible, setIsVisible] = useState(false);
    const [descriptionPrefix, setDescriptionPrefix] = useState('');

    useEffect(() => {
        if (pageTitle) {
            if (pageTitle === 'profile') {
                setDescriptionPrefix('This profile is only available');
            } else {
                // competitions, pinned-posts, featured-players
                setDescriptionPrefix('This feature is only available');
            }
        }
    }, [pageTitle]);

    useEffect(() => {
        const timer = setTimeout(() => setIsVisible(true), 100);
        return () => clearTimeout(timer);
    }, []);

    const onLoginClick = () => {
        const urlParams = new URLSearchParams(window.location.search);
        const params = urlParams.toString();
        const from = location.pathname + (params ? '?' + params : '');
        navigate('/login', { state: { from } });
    };

    const onGooglePlayClick = () => {
        window.open(
            'https://play.google.com/store/apps/details?id=com.playerapp.playerapp&pcampaignid=web_share',
            '_blank'
        );
    };
    const onAppleStoreClick = () => {
        window.open(
            'https://apps.apple.com/gb/app/player-the-footballers-app/id6503473876',
            '_blank'
        );
    };

    const onPlayerSignupClick = () => {
        window.open('https://join.playerapp.co', '_blank');
    };

    const onNonPlayerSignupClick = () => {
        window.open('https://join.playerapp.co/recruit', '_blank');
    };

    return (
        <div
            className='min-h-screen w-full bg-cover bg-center bg-no-repeat'
            style={{
                backgroundImage: `url(${featuredPlayersBg})`
            }}
        >
            <div
                className={`container mx-auto absolute bottom-0 flex flex-col gap-6 transition-all duration-700 ease-out ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'}`}
            >
                <img
                    src={playerAppLogo}
                    alt='Player App Logo'
                    className={`w-[140px] h-[140px] mx-auto transition-all duration-1000 ease-out ${isVisible ? 'scale-100 opacity-100' : 'scale-95 opacity-0'}`}
                    style={{ transitionDelay: '200ms' }}
                />

                <h1
                    className={`px-4 text-[20px] leading-[28px] font-bold text-white text-center transition-all duration-700 ease-out ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0'}`}
                    style={{ transitionDelay: '400ms' }}
                >
                    {descriptionPrefix} <br />
                    {isLoggedIn ? 'on the PLAYER app' : 'to PLAYER users'}
                </h1>
                {isLoggedIn ? (
                    <div
                        className={`flex mt-10 justify-between px-6 pt-6 pb-5 bg-[#012531] border-t border-[#FFFFFF1A] rounded-t-lg transition-all duration-700 ease-out ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-6 opacity-0'}`}
                        style={{ transitionDelay: '600ms' }}
                    >
                        <img
                            onClick={onGooglePlayClick}
                            src={googlePlayImage}
                            alt='Google Play'
                            className='w-[47%] cursor-pointer hover:scale-105 transition-transform duration-200'
                        />
                        <img
                            onClick={onAppleStoreClick}
                            src={appleStoreImage}
                            alt='Apple Store'
                            className='w-[47%] cursor-pointer hover:scale-105 transition-transform duration-200'
                        />
                    </div>
                ) : (
                    <div
                        className={`flex flex-col gap-8 pb-5 pt-6 transition-all duration-700 ease-out ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-6 opacity-0'}`}
                        style={{ transitionDelay: '600ms' }}
                    >
                        <BigButtons
                            green={true}
                            label='Log in'
                            onClick={onLoginClick}
                        />
                        <p
                            className='text-white text-center text-[14px] transition-all duration-500 ease-out'
                            style={{ transitionDelay: '800ms' }}
                        >
                            New to PLAYER? Sign up below.
                        </p>
                        <div
                            className='flex flex-col gap-3 transition-all duration-500 ease-out'
                            style={{ transitionDelay: '1000ms' }}
                        >
                            <BigButtons
                                white={true}
                                label='PLAYERS'
                                onClick={onPlayerSignupClick}
                            />
                            <BigButtons
                                white={true}
                                label='AGENTS, SCOUTS, COACHES'
                                onClick={onNonPlayerSignupClick}
                            />
                        </div>
                    </div>
                )}
                <div className='flex justify-center items-center gap-10 pb-14'>
                    <a
                        href='https://join.playerapp.co/tcs'
                        target='_blank'
                        className='text-white text-[10px] underline'
                    >
                        Terms & Conditions
                    </a>
                    <a
                        href='https://join.playerapp.co/privacypolicy'
                        target='_blank'
                        className='text-white text-[10px] underline'
                    >
                        Privacy Policy
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Placeholder;
